<template>
  <NavbarOne />
  <PageBanner
    pageTitle="اتصل بنا"
    subTitle="نحن هنا للإجابة على جميع استفساراتك ومساعدتك في اختيار أفضل اشتراك IPTV. تواصل معنا وسنكون سعداء بخدمتك في أسرع وقت."
    :pageBannerImage="pageBannerImg"
  />
  <ContactInfo />
  <SendUsMessage />
  <PartnerLogo />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import ContactInfo from "@/components/ContactUs/ContactInfo.vue";
import SendUsMessage from "@/components/ContactUs/SendUsMessage.vue";
import PartnerLogo from "@/components/ContactUs/PartnerLogo.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ContactUsPage",
  components: {
    NavbarOne,
    PageBanner,
    ContactInfo,
    SendUsMessage,
    PartnerLogo,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "اتصل بنا | دعم واستفسارات اشتراكات IPTV",
      meta: [
        {
          name: "description",
          content:
            "تواصل معنا للحصول على المساعدة أو الاستفسار عن اشتراكات IPTV، القنوات العربية والعالمية، الأفلام، المسلسلات، والأسعار. فريق الدعم جاهز للإجابة على جميع أسئلتك.",
        },
        {
          name: "keywords",
          content:
            "اتصل بنا, دعم IPTV, خدمة العملاء, اشتراك IPTV, استفسارات IPTV, قنوات عربية, دعم فني",
        },
        {
          property: "og:title",
          content: "اتصل بنا | دعم واستفسارات اشتراكات IPTV",
        },
        {
          property: "og:description",
          content:
            "تواصل مع فريق الدعم للحصول على المساعدة والإجابة عن جميع استفساراتك المتعلقة بخدمات IPTV.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/contact-us",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-7.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>